import { all, put, race, take, select, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { getToken, getLocale, getCustomData } from '@global/selectors'

import {
    CONTRACTS_LOAD_PARTICIPANTS,
    CONTRACTS_LOAD_PARTICIPANTS_REQUEST,
    CONTRACTS_PARTICIPANTS_DATA_RECEIVED,
    CONTRACTS_PARTICIPANTS_LOADING_TRUE,
    CONTRACTS_PARTICIPANTS_LOADING_FALSE,
} from './constants'

import {
    contractsLoadDocParticipantsRequest,
    contractsDocParticipantsLoadingTrue,
    contractsDocParticipantsLoadingFalse,
    contractsDocParticipantsDataReceived,
} from './actions'

import { blockSaveCustomData } from '../../../../../../../../../../../components/Workspace/components/HocBlock/actions'
import config from '../../../../../../../../../../../../../config'

const CONTRACTS_LOAD_PARTICIPANTS_REQUEST_SUCCESS = (entId, docId) =>
    `${CONTRACTS_LOAD_PARTICIPANTS_REQUEST(entId, docId)}_${SUCCESS}`
const CONTRACTS_LOAD_PARTICIPANTS_REQUEST_FAILED = (entId, docId) =>
    `${CONTRACTS_LOAD_PARTICIPANTS_REQUEST(entId, docId)}_${FAILED}`

function* contractsParticipantsLoadSaga(action) {
    const module = _.get(action, 'data.module', null)
    const blockKey = _.get(action, 'data.blockKey', null)
    const id = _.get(action, 'data.entId', null)
    const level = _.get(action, 'data.level', null)
    const docId = _.get(action, 'data.docId', null)

    const locale = yield select(getLocale)
    const token = yield select(getToken, id, module)

    const lang = config.languages[locale].requestKey

    if (!module || !blockKey || !id || !level) return null

    yield put(
        contractsDocParticipantsLoadingTrue(module, blockKey, id, {
            [docId]: {
                isLoading: true,
            },
        })
    )

    const result = yield all({
        response: race({
            success: take(CONTRACTS_LOAD_PARTICIPANTS_REQUEST_SUCCESS(id, docId)),
            failed: take(CONTRACTS_LOAD_PARTICIPANTS_REQUEST_FAILED(id, docId)),
        }),
        request: put(contractsLoadDocParticipantsRequest(module, blockKey, id, docId, level, lang, token)),
    })

    if (result.response.success) {
        const data = _.get(result, 'response.success.payload.response.body.participants', [])

        const newParticipant = {
            [docId]: {
                isLoading: false,
                dataLocale: locale,
                data,
            },
        }

        yield put(contractsDocParticipantsDataReceived(module, blockKey, id, newParticipant))
    } else {
        yield put(
            contractsDocParticipantsLoadingFalse(module, blockKey, id, {
                [docId]: {
                    data: [],
                    isLoading: false,
                },
            })
        )
    }

    return null
}

function* contractsChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.contracts.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const customData = yield select(getCustomData, module, blockKey, id)
    const incomingParticipantChange = _.get(action, 'data.customData', null)

    yield put(
        blockSaveCustomData(module, id, blockKey, {
            ...customData,
            participants: {
                ...customData.participants,
                ...incomingParticipantChange,
            },
        })
    )

    return null
}

export default function* participantsSaga() {
    yield all([
        takeEvery(CONTRACTS_LOAD_PARTICIPANTS, contractsParticipantsLoadSaga),
        takeEvery(CONTRACTS_PARTICIPANTS_LOADING_TRUE, contractsChangeCustomData),
        takeEvery(CONTRACTS_PARTICIPANTS_LOADING_FALSE, contractsChangeCustomData),
        takeEvery(CONTRACTS_PARTICIPANTS_DATA_RECEIVED, contractsChangeCustomData),
    ])
}
